import { render, staticRenderFns } from "./CategoryAddViewModal.vue?vue&type=template&id=744f85b6&"
import script from "./CategoryAddViewModal.vue?vue&type=script&lang=js&"
export * from "./CategoryAddViewModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports